import OrdersManagerDashboard from "./OrdersManagerDashboard"

export default  OrdersManagerDashboard;


// WEBPACK FOOTER //
// ./src/components/App/OrdersManagerDashboard/index.js